import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import {
  Box,
  Button,
  FormGroup,
  FormLabel,
  Grid,
  Skeleton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import themeVars from "../../../src/styles/_variables.scss";
import "../../styles/_all.scss";
import WidgetCard from "./WidgetCard";

import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import ViewCarouselOutlinedIcon from "@mui/icons-material/ViewCarouselOutlined";
import axios from "axios";
import { GET_WIDGET_ELEMENT, WIDGET_FIRE_LISTEN } from "./WidgetFunctions";
import { validatePostInput } from "../../services/contentServices";
const Widget = () => {
  const generateSessionId = () => {
    localStorage.setItem("widgetSession", +new Date() + Math.floor(Math.random()));
    setGenerated(false);
    return +new Date() + Math.floor(Math.random());
  };
  const [ideaVal, setIdeaVal] = useState(localStorage.getItem("widgetInput") || "");
  const [postType, setPostType] = useState([
    {
      active: true,
      value: "single_image",
      icon: (
        <ImageOutlinedIcon
          fontSize="large"
          sx={{ height: { sm: "64px", xs: "50px" }, width: { sm: "64px", xs: "50px" } }}
        />
      ),
      text: "Image",
    },
    {
      active: false,
      value: "carousel",
      icon: (
        <ViewCarouselOutlinedIcon
          fontSize="large"
          sx={{ height: { sm: "64px", xs: "50px" }, width: { sm: "64px", xs: "50px" } }}
        />
      ),
      text: "Carousel",
    },
    {
      active: false,
      value: "video",
      icon: (
        <SmartDisplayOutlinedIcon
          fontSize="large"
          sx={{ height: { sm: "64px", xs: "50px" }, width: { sm: "64px", xs: "50px" } }}
        />
      ),
      text: "Video",
    },
  ]);
  const [handleValue, setHandleValue] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [showBanner, setShowBanner] = useState(true);
  const [fetchedData, setFetchedData] = useState(null);
  const [generated, setGenerated] = useState(true);
  const [inputErr, setInputErr] = useState({
    err: false,
    text: "",
  });
  const [inputDisabled, setInputDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const selectType = (value) => {
    const typeArr = [...postType];

    typeArr.find((el) => el.value === value).active = true;

    typeArr.filter((el) => el.value !== value).map((el) => (el.active = false));
    setPostType(typeArr);
  };
  const SessionId = localStorage.getItem("widgetSession") || generateSessionId();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const existingParams = Object.fromEntries(urlSearchParams.entries());
  const generatePost = (mode) => {
    try {
      window.fbq("track", "Lead");
    } catch (error) {
      console.log("error fbq");
    }

    if (generated && mode === "button") {
      const newParams = new URLSearchParams({
        ...existingParams,
        session_id: SessionId,
      });

      window.open(`https://app.predis.ai/signup?${newParams.toString()}`, "_blank");
    } else {
      if (inputErr.err) {
        return;
      }

      setInputErr({ err: false, text: "" });
      setShowBanner(false);
      setLoading(true);
      const mediaType = postType.find((el) => el.active).value;
      const sendData = new URLSearchParams({
        post_idea: ideaVal.trim(),
        media_type: mediaType,
        session_id: SessionId,
      });
      axios.get(`https://brain.predis.ai/tools/create_post/?${sendData}`).then((res) => {
        if (res.data.data[0].status === "completed") {
          setLoading(false);
          if (res.data.data[0].media_type === "carousel") {
            res.data.data[0]["creative_details"] = res.data.data[0].creative_details[0].pages.map(
              (el) => el.url
            );
            setFetchedData(res.data.data);
          } else {
            setFetchedData(res.data.data);
          }
        }
        res.data.data[0].status === "completed" && setDisabled(false);
        if (res.data.data[0].status === "inProgress") {
          setDisabled(true);
          WIDGET_FIRE_LISTEN(
            res.data.fbse_token,
            res.data.uid,
            res.data.job_id,
            res.data.data[0].event_id,
            (mediaType, status, caption, url, thumb_url) => {
              const modifyArr = [...res.data.data];
              if (status !== "completed") {
                modifyArr[0].status = status;
                setFetchedData(modifyArr);
              }
              if (mediaType !== "carousel" && status === "completed") {
                modifyArr[0].status = "completed";
                modifyArr[0]["creative_details"] = [{ url, thumb_url }];
                modifyArr[0]["caption"] = caption;
                setFetchedData(modifyArr);
                setDisabled(false);
              }
              if (mediaType === "carousel" && status === "completed") {
                modifyArr[0].status = "completed";
                modifyArr[0]["creative_details"] = url.pages.map((el) => el.url);
                modifyArr[0]["caption"] = caption;
                setFetchedData(modifyArr);
                setDisabled(false);
              }
              if (status === "completed") {
                setGenerated(true);
                setInputDisabled(true);
                localStorage.setItem("widgetInput", ideaVal);
                localStorage.setItem("widgetSelectedType", mediaType);
                setLoading(false);
              }
            }
          );
        }
      });
    }
  };

  const downloadPost = () => {
    if (fetchedData[0].media_type === "video") {
      const newParams = new URLSearchParams({
        ...existingParams,
        session_id: SessionId,
      });
      window.open(`https://app.predis.ai/signup?${newParams.toString()}`, "_blank");
    } else {
      const downloadURL = "users/download_creative";
      const params = new URLSearchParams({
        session_id: SessionId,
        media_type: fetchedData[0].media_type,
      });
      axios
        .get(`https://brain.predis.ai/${downloadURL}/?${params.toString()}`, {
          responseType: "blob",
        })
        .then((response) => {
          // create file link in browser's memory
          const href = URL.createObjectURL(response.data);
          const filename = response.headers["content-disposition"].split("filename=")[1];
          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        });
    }
  };
  const shareFn = () => {
    window.navigator.clipboard.writeText("https://app.predis.ai");
  };
  useEffect(() => {
    if (localStorage.getItem("widgetSelectedType")) {
      const newPostType = [...postType];
      const selectedType = localStorage.getItem("widgetSelectedType");
      newPostType.find((el) => el.value === selectedType).active = true;
      newPostType.filter((el) => el.value !== selectedType).map((el) => (el.active = false));
      setPostType(newPostType);
      setInputDisabled(true);
      generatePost("effect");
    } else {
      setGenerated(false);
    }
  }, []);

  return (
    <Box p={1} className="widgetTypography" height="100%">
      <Grid container p={1} justifyContent="center">
        <Grid item sm={6} xs={12}>
          <Box textAlign={"center"}>
            <Typography variant="h3" fontWeight={600}>
              Try it Yourself!
            </Typography>
            <Typography variant="h6">Enter a short description and see the magic ✨</Typography>
          </Box>
          <Box p={1} marginTop="4rem">
            <FormGroup>
              <TextField
                label="What do you want to post about?"
                value={ideaVal}
                multiline
                error={inputErr.err}
                helperText={inputErr.text}
                inputProps={{ maxLength: 100 }}
                InputLabelProps={{ shrink: true }}
                disabled={inputDisabled}
                placeholder={"Tips for a healthy breakfast"}
                onChange={(e) => {
                  if (validatePostInput(e.target.value) === undefined) {
                    setInputErr({
                      err: true,
                      text: "Input is too short please write at least 20 characters and 3 words.",
                    });
                  } else {
                    setInputErr({ err: false, text: "" });
                  }
                  setIdeaVal(e.target.value);
                }}
              />
              <Box my={1} marginTop="1rem">
                <FormLabel>Select the type of post to generate</FormLabel>
                <Stack direction={"row"} gap={3} justifyContent="center">
                  {postType.map((el) => {
                    return (
                      <>
                        <Box
                          textAlign="center"
                          sx={{ cursor: "pointer" }}
                          onClick={() => selectType(el.value)}
                        >
                          <Box
                            p={1}
                            border={el.active && `2px solid ${themeVars.primary}`}
                            borderRadius="4px"
                          >
                            {el.icon}
                          </Box>
                          <Typography>{el.text}</Typography>
                        </Box>
                      </>
                    );
                  })}
                </Stack>
              </Box>
            </FormGroup>
            {/* <FormGroup>
              <Box>
                <Box my={1}>
                  <TextField
                    label="Enter your handle/business name"
                    fullWidth
                    value={handleValue}
                    size="small"
                    sx={{ marginLeft: ".5rem" }}
                    onChange={(e) => setHandleValue(e.target.value)}
                    placeholder="Predis.ai"
                  />
                </Box>
              </Box>
            </FormGroup> */}
            <Box textAlign={"center"} my={2}>
              <Button
                variant="contained"
                onClick={() => generatePost("button")}
                disabled={ideaVal.trim().length === 0 || loading}
              >
                {generated ? "Generate More Posts" : "Generate Post"}
              </Button>
            </Box>
          </Box>
          <Typography
            textAlign={"center"}
            sx={{ marginTop: { md: 12, xs: 2 }, marginBottom: { md: 1, xs: 2 } }}
          >
            Edit this Post and publish to your Instagram, Facebook, LinkedIn and Pinterest feeds in
            a click
          </Typography>
        </Grid>
        <Grid item sm={6} md={5} xs={12}>
          <Box>
            {/* <Typography variant="h6" textAlign={"center"}>
              Predis generated Post
            </Typography> */}
            <Box>
              <WidgetCard
                ELEM={
                  fetchedData && fetchedData[0].creative_details ? (
                    GET_WIDGET_ELEMENT(
                      fetchedData[0].media_type,
                      fetchedData[0].status,
                      fetchedData[0].media_type !== "carousel"
                        ? [fetchedData[0]?.creative_details[0]?.url]
                        : [...fetchedData[0]?.creative_details],
                      fetchedData[0]?.creative_details[0]?.thumb_url
                    )
                  ) : loading ? (
                    <Skeleton height={"300px"} width="100%" />
                  ) : (
                    <img src="widgetSample.jpeg" />
                  )
                }
                showBanner={showBanner}
                handleName={handleValue ? handleValue : "Your Handle Name"}
                disabled={disabled}
                caption={
                  fetchedData
                    ? fetchedData[0].caption
                    : `Starting your day with a nutritious breakfast is a great way to set yourself up for
                success. Here are some tips to help you make sure your breakfast is as healthy as
                possible:\n\n-Choose whole grain options like oatmeal or whole wheat
                toast.\n-Include a protein source like eggs, yogurt, or peanut butter.\n-Add some
                healthy fats like nuts or avocado.\n-Throw in some fresh or frozen fruit for
                sweetness and vitamins.\n\nBy following these tips, you can be sure you're starting
                your day off right with a nut...`
                }
              />
            </Box>
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              my={2}
              sx={{
                filter: disabled ? "blur(2px)" : "",
                pointerEvents: disabled ? "none" : "auto",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  const newParams = new URLSearchParams({
                    ...existingParams,
                    session_id: SessionId,
                  });
                  window.open(`https://app.predis.ai/signup?${newParams.toString()}`, "_blank");
                }}
                sx={{ mr: 2 }}
              >
                <BorderColorOutlinedIcon fontSize="medium" sx={{ marginX: ".5rem" }} />
                Edit
              </Button>
              <Box display={"flex"} justifyContent="center" gap={2} my={1}>
                <Box
                  sx={{
                    cursor: "pointer",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={downloadPost}
                >
                  <CloudDownloadOutlinedIcon fontSize="large" sx={{ marginRight: "0.3rem" }} />
                  {fetchedData && fetchedData[0].media_type === "video" ? (
                    <Typography>Login to Download</Typography>
                  ) : (
                    <Typography>Download</Typography>
                  )}
                </Box>
                {/* <Box sx={{ cursor: "pointer" }} onClick={shareFn}>
                  <ShareOutlinedIcon fontSize="large" />
                  <Typography>Share</Typography>
                </Box> */}
              </Box>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Widget;
